import { render, staticRenderFns } from "./RebuildRoot.vue?vue&type=template&id=6ed0fef6"
import script from "./RebuildRoot.vue?vue&type=script&lang=js"
export * from "./RebuildRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports